import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { AccessGroupUrl } from './AccessGroupUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { AccessGroupDto } from '../schema/types';
import { AccessGroupSchema } from '../schema/AccessGroupSchema';

const getAccessGroup = ({ id }: { id: number }) => {
  return apiClient
    .get<AccessGroupDto>(expand(AccessGroupUrl.ACCESS_GROUP, { id }))
    .then((response) => AccessGroupSchema.parse(response.data));
};

export const useAccessGroupQuery = createApiQueryHook(
  ['access-group'],
  getAccessGroup
);
